import { useQuery } from '@tanstack/react-query'
import { groupReviewApi } from '@/services/api/entity-resolution-groups'

export interface EntityResolutionCount {
  /** Entities sitting in a hidden review group awaiting resolution. */
  pending: number
  isLoading: boolean
  isError: boolean
}

/**
 * Pending entity-resolution count for a case. Shared by the overview's
 * EntityResolutionCard and CaseJourneyStrip so they hit the cache once.
 */
export function useEntityResolutionCount(caseId: string): EntityResolutionCount {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['case', caseId, 'entity-resolution', 'groups', 'pending-count'],
    queryFn: () => groupReviewApi.pendingCount(caseId),
    staleTime: 60_000,
  })
  return { pending: data?.candidates ?? 0, isLoading, isError }
}
